import React from "react";
import Chart from "../../Chart";
import ExampleBarChart from "../../../../components/Chart/ExampleBarChart";

class BarChartExampleApplet extends Chart {

    render() {
        return <ExampleBarChart applet={this}
                          attributes={this.state.Attributes}
                          xAxis={this.state.xAxis}
                          yAxis={this.state.yAxis}
                          series={this.state.Series}
                          sx={this.state.sx}
                          enterpriseComponent={this.getEnterpriseComponent()} />;
    }

    state = {
        Name: "BarChartExampleApplet",
        Menu: {
            options: [
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        Attributes: {
            Height: 300,
            Margin: {right: 24},
        },
        xAxis: [
            {
                scaleType: 'band',
                data: []
            }
        ],
        yAxis: [
            { width: 50 }
        ],
        zAxis: undefined,
        Series: [
            {
                type: "bar",
                data: [],
                id: "pvId",
                label: "pv",
            },
            {
                type: "bar",
                id: "uvId",
                data: [],
                label: 'uv'
            }
        ]
    }
}

export default BarChartExampleApplet;
